/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками Smart Auto Collect
 */

/**
 * Сервис управления настройками Smart Auto Collect
 */
export class SacServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования настроек Smart Auto Collect
   */
  EditSac = (req: Pick<EditSacRequestDto, "updateMask"> & { data: SacRequestDto & fm.RequireAtLeastOne<SacRequestDto> }, init?: RequestInit): Promise<EditSacResponseDto> => {
    return fm.request<Pick<EditSacRequestDto, "updateMask"> & { data: SacRequestDto & fm.RequireAtLeastOne<SacRequestDto> }, EditSacResponseDto>(`${this.host}/device/api/v1/sac`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек Smart Auto Collect
   */
  GetSac = (req?: GetSacRequestDto, init?: RequestInit): Promise<GetSacResponseDto> => {
    return fm.request<GetSacRequestDto, GetSacResponseDto>(`${this.host}/device/api/v1/sac${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос редактирования настроек Smart Auto Collect
 */
export type EditSacRequestDto = {
  /**
   * Настройки Smart Auto Collect
   */
  data: SacRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования настроек Smart Auto Collect
 */
export type EditSacResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки Smart Auto Collect
   */
  readonly data: SacResponseDto
  /**
   * Ошибка
   */
  readonly error: EditSacResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditSacResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditSacResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения настроек Smart Auto Collect
 */
export type GetSacRequestDto = {
}
/**
 * Ответ на запрос получения настроек Smart Auto Collect
 */
export type GetSacResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки Smart Auto Collect
   */
  readonly data: SacResponseDto
}>
/**
 * Настройки Smart Auto Collect
 */
export type SacRequestDto = {
  /**
   * Флаг включения Smart Auto Collect
   */
  isSacOn: boolean
  /**
   * Минимальный номер квартиры
   */
  minFlatNumber?: number
  /**
   * Максимальный номер квартиры
   */
  maxFlatNumber?: number
  /**
   * Маска UID RFID ключа.
   * Пример 04**********80 = что означает, что uid ключа должен начинаться с 04, иметь 14 знаков и заканчиваться на 80.
   * Пример  ******** = что означает что uid ключа должен н иметь 8 знаков
   */
  keyMask?: string
}
/**
 * Настройки Smart Auto Collect
 */
export type SacResponseDto = {
  /**
   * Флаг включения Smart Auto Collect
   */
  isSacOn: boolean
  /**
   * Минимальный номер квартиры
   */
  minFlatNumber: number
  /**
   * Максимальный номер квартиры
   */
  maxFlatNumber: number
  /**
   * Маска UID RFID ключа.
   * Пример 04**********80 = что означает, что uid ключа должен начинаться с 04, иметь 14 знаков и заканчиваться на 80.
   * Пример  ******** = что означает что uid ключа должен н иметь 8 знаков
   */
  keyMask: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос редактирования настроек Smart Auto Collect
   */
  "EditSacRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек Smart Auto Collect",
    "fields": {
      /**
       * Настройки Smart Auto Collect
       */
      "data": {
        "type": "Sac",
        "text": "Настройки Smart Auto Collect",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования настроек Smart Auto Collect
   */
  "EditSacResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования настроек Smart Auto Collect",
    "fields": {
      /**
       * Настройки Smart Auto Collect
       */
      "data": {
        "type": "Sac",
        "text": "Настройки Smart Auto Collect",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "EditSacResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditSacResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения настроек Smart Auto Collect
   */
  "GetSacRequest": {
    "kind": "class",
    "text": "Запрос получения настроек Smart Auto Collect",
  },
  /**
   * Ответ на запрос получения настроек Smart Auto Collect
   */
  "GetSacResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек Smart Auto Collect",
    "fields": {
      /**
       * Настройки Smart Auto Collect
       */
      "data": {
        "type": "Sac",
        "text": "Настройки Smart Auto Collect",
      },
    },
  },
  /**
   * Настройки Smart Auto Collect
   */
  "Sac": {
    "kind": "class",
    "text": "Настройки Smart Auto Collect",
    "fields": {
      /**
       * Флаг включения Smart Auto Collect
       */
      "isSacOn": {
        "type": "bool",
        "text": "Флаг включения Smart Auto Collect",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Минимальный номер квартиры
       */
      "minFlatNumber": {
        "type": "int32",
        "text": "Минимальный номер квартиры",
      },
      /**
       * Максимальный номер квартиры
       */
      "maxFlatNumber": {
        "type": "int32",
        "text": "Максимальный номер квартиры",
      },
      /**
       * Маска UID RFID ключа.
       * Пример 04**********80 = что означает, что uid ключа должен начинаться с 04, иметь 14 знаков и заканчиваться на 80.
       * Пример  ******** = что означает что uid ключа должен н иметь 8 знаков
       */
      "keyMask": {
        "type": "string",
        "text": "Маска UID RFID ключа.\nПример 04**********80 = что означает, что uid ключа должен начинаться с 04, иметь 14 знаков и заканчиваться на 80.\nПример  ******** = что означает что uid ключа должен н иметь 8 знаков",
      },
    },
  },
}